import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/modules/auth/forgetPassword/ForgetPass.tsx");
